import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig, loginRequest } from "./auth.config";
const msalInstance = new PublicClientApplication(msalConfig);

export const getToken = async (): Promise<string | null> => {

  const accounts = msalInstance.getAllAccounts();
  if (accounts.length > 0) {
    const request = {
      scopes: loginRequest.scopes,
      account: accounts[0]
    }
    const accessToken = await msalInstance.acquireTokenSilent(request)
      .then((response) => {
        return response.idToken;
      }).catch(error => {
        // Do not fallback to interaction when running outside the context of MsalProvider. Interaction should always be done inside context.
        console.log(error);
        return null;
      });

    return accessToken;
  }
  return null;
}

export const logout = () => {
  msalInstance.logoutRedirect();
}

/*export const getUserEmail = (): string => {
  let username = '';

  try {
    const account = msalInstance.getAllAccounts()[0];
    username = account.username;
  }
  catch (error) {
    console.error('getUserEmail() error', error);
  }

  return username;
}*/
